'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--CircularGraph';

var EntypoCircularGraph = function EntypoCircularGraph(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M17.584,9.372h2c-0.065-1.049-0.293-2.053-0.668-2.984L17.16,7.402C17.384,8.025,17.531,8.685,17.584,9.372z M14.101,1.295c-0.955-0.451-1.99-0.757-3.086-0.87v2.021c0.733,0.097,1.433,0.295,2.084,0.585L14.101,1.295z M16.242,5.622l1.741-1.005c-0.591-0.878-1.33-1.645-2.172-2.285l-1.006,1.742C15.354,4.52,15.836,5.042,16.242,5.622z M10.014,17.571c-4.197,0-7.6-3.402-7.6-7.6c0-3.858,2.877-7.036,6.601-7.526V0.424c-4.833,0.5-8.601,4.583-8.601,9.547c0,5.303,4.298,9.601,9.601,9.601c4.824,0,8.807-3.563,9.486-8.2H17.48C16.822,14.899,13.732,17.571,10.014,17.571z' })
    );
};

exports.default = EntypoCircularGraph;
module.exports = exports['default'];